export const invalidPhoneNumberMessage =
	"0から始まる正しい電話番号を入力してください。"
export const invalidCancelTypeToSendInvoiceMessage =
	"キャンセル種別を設定してください。"
